import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  getIntegrationDashboardNumber,
  getIntegrationMode,
  isIntegrationDashboardEnabled,
  isIntegrationFilterBarEnabled,
  isIntegrationMasterEnabled,
  isIntegrationPrincipalDirectionEnabled,
  isIntegrationSecondaryDirectionEnabled,
  isIntegrationViewEnabled,
  isLikeCompatibilityEnabled,
  isSemanticSearchModeBadgeEnabled,
  isM4FromTableEnabled,
  isPanelComboFromTableEnabled,
  isPanelLexicalFromTableEnabled,
  isSemanticSearchMasterEnabled,
  SEMANTIC_MODULE_KEYS,
} from '../../app/helpers/semanticSearchConfigHelper';

const AdminSemanticSearchScreen = () => {
  const configuration = useSelector((state) => state.configuration);

  const master = isSemanticSearchMasterEnabled(configuration);
  const likeCompat = isLikeCompatibilityEnabled(configuration);
  const modeBadge = isSemanticSearchModeBadgeEnabled(configuration);
  const integration = isIntegrationMasterEnabled(configuration);
  const integrationPrincipal = isIntegrationPrincipalDirectionEnabled(configuration);
  const integrationSecondary = isIntegrationSecondaryDirectionEnabled(configuration);
  const dashboard = isIntegrationDashboardEnabled(configuration);
  const view = isIntegrationViewEnabled(configuration);
  const mode = getIntegrationMode(configuration);
  const dashN = getIntegrationDashboardNumber(configuration);
  const filterBar = isIntegrationFilterBarEnabled(configuration);
  const panelFromTable = isPanelLexicalFromTableEnabled(configuration);
  const panelComboFromTable = isPanelComboFromTableEnabled(configuration);
  const m4FromTable = isM4FromTableEnabled(configuration);

  return (
    <div className="container mt-4">
      <h2>Búsqueda Semántica</h2>
      <p className="text-muted">
        Stub de flags. La parametrización de LIKE/combos del panel, la barra del puente y M4 está en{' '}
        <Link to="/admin-semantic-search-filters">Filtros de búsqueda</Link>.
      </p>
      <ul>
        <li>
          Master <code>semantic.search.enabled</code>: <strong>{String(master)}</strong>
        </li>
        <li>
          LIKE compatibility: <strong>{String(likeCompat)}</strong>
        </li>
        <li>
          Etiqueta de modo (híbrida / semántica): <strong>{String(modeBadge)}</strong>
        </li>
        <li>
          Integration master: <strong>{String(integration)}</strong>
        </li>
        <li>
          Integration principal / secondary: <strong>{String(integrationPrincipal)}</strong> /{' '}
          <strong>{String(integrationSecondary)}</strong>
        </li>
        <li>
          UI view / dashboard: <strong>{String(view)}</strong> / <strong>{String(dashboard)}</strong>
        </li>
        <li>
          Mode / dashboard.number: <strong>{mode}</strong> / <strong>{dashN}</strong>
        </li>
        <li>
          Barra de filtros puente: <strong>{String(filterBar)}</strong>
        </li>
        <li>
          Panel LIKE desde tabla (compat, default false): <strong>{String(panelFromTable)}</strong>
        </li>
        <li>
          Panel L3 combos desde tabla (compat, default false): <strong>{String(panelComboFromTable)}</strong>
        </li>
        <li>
          M4 desde tabla (compat, default false): <strong>{String(m4FromTable)}</strong>
        </li>
      </ul>
      <p className="small text-muted">
        Destinos (listas pipe por origen):{' '}
        <code>semantic.search.integration.principal|secondary.&#123;sourceModule&#125;</code> — ej.{' '}
        <code>financial|assistance|…</code> (vacío = sin destinos). Módulos: {SEMANTIC_MODULE_KEYS.join(', ')}.
      </p>
      <p>
        Menús relacionados:{' '}
        <Link to="/admin-semantic-search-filters">/admin-semantic-search-filters</Link>,{' '}
        <Link to="/admin-semantic-fields">/admin-semantic-fields</Link>,{' '}
        <Link to="/admin-semantic-jobs">/admin-semantic-jobs</Link>,{' '}
        <Link to="/admin-semantic-interests">/admin-semantic-interests</Link>,{' '}
        <Link to="/admin-support-forms">/admin-support-forms</Link>
      </p>
    </div>
  );
};

export default AdminSemanticSearchScreen;
